var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsThreeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.875C11.0355 11.875 11.875 11.0355 11.875 10C11.875 8.96447 11.0355 8.125 10 8.125C8.96447 8.125 8.125 8.96447 8.125 10C8.125 11.0355 8.96447 11.875 10 11.875Z",
    stroke: "#1A181E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.875C4.78553 11.875 5.625 11.0355 5.625 10C5.625 8.96447 4.78553 8.125 3.75 8.125C2.71447 8.125 1.875 8.96447 1.875 10C1.875 11.0355 2.71447 11.875 3.75 11.875Z",
    stroke: "#1A181E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 11.875C17.2855 11.875 18.125 11.0355 18.125 10C18.125 8.96447 17.2855 8.125 16.25 8.125C15.2145 8.125 14.375 8.96447 14.375 10C14.375 11.0355 15.2145 11.875 16.25 11.875Z",
    stroke: "#1A181E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsThreeOutline);
export default __webpack_public_path__ + "static/media/dots-three-outline.997831fc35e0d4215e10237fd4e511ba.svg";
export { ForwardRef as ReactComponent };